// extracted by mini-css-extract-plugin
export default {"content":"style_content__L2JP1","description":"style_description__VKq1M","myButton":"style_myButton__j5M41"};